export const licensedTitlesPermissions = {
  LICENSED_TITLES_VIEW: {
    enabled: ['licensed_titles_view', 'licensed_titles_edit'],
  },
  LICENSED_TITLES_EDIT: {
    enabled: ['licensed_titles_edit'],
    disabled: ['licensed_titles_view'],
  },
};
